import { screenSignal } from './screenScope';

/*
| Mobile filter collapse: the per-screen filter bars (`.qf-bars`) hide behind a
| "Filtry" toggle on small screens (CSS-driven). Here we wire the toggle and keep
| an active-filter count on its label. Screen-scoped — re-runs after each soft-nav.
*/
export function initQuickFilters(): void {
    const toggle = document.querySelector<HTMLButtonElement>('[data-qf-toggle]');
    const bars = document.querySelector<HTMLElement>('[data-qf-bars]');
    if (!toggle || !bars) {
        return;
    }

    const baseLabel = (toggle.textContent ?? '').trim() || 'Filtry';

    const refresh = (): void => {
        const active = Array.from(bars.querySelectorAll<HTMLElement>('[aria-pressed="true"]'))
            .filter((el) => (el.textContent ?? '').trim().toLowerCase() !== 'vše').length;
        toggle.textContent = active > 0 ? `${baseLabel} (${active})` : baseLabel;
    };

    toggle.addEventListener('click', () => {
        const open = bars.classList.toggle('qf-bars--open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }, { signal: screenSignal() });

    // The pills flip their own aria-pressed; recompute the badge after the click settles.
    bars.addEventListener('click', () => window.setTimeout(refresh, 0), { signal: screenSignal() });

    refresh();
}
